import { render, staticRenderFns } from "./AttachmentSelector.vue?vue&type=template&id=65b9291c"
import script from "./AttachmentSelector.vue?vue&type=script&lang=js"
export * from "./AttachmentSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports